import { TcPageTemplateNames } from 'src/configuration/tagcommander'

import { Crosslink } from '../../types/fam-graphql'
import { TcCLickArgs } from '../tcClick/tcClick'

import { crossLinkCardTransformer } from '.'

export const crossLinkTransformer = (
  items: any,
  t: any,
  tcVars?: {
    template: TcPageTemplateNames
  } & TcCLickArgs,
  isOffline?: boolean
) =>
  items?.map((cl: Crosslink) =>
    crossLinkCardTransformer(cl, t, tcVars, isOffline)
  )
